const isToday = (date) => {
  return date.isSame(new Date(), 'day');
};

export default isToday;
